import { Alert } from 'antd'
import { ErrorResponse } from 'shared/types/ErrorResponse'

import React from 'react'

import { Button } from '../Button'
import { Space } from '../Space'

interface ErrorProps {
  error: ErrorResponse
  onRefetch?: () => void
}

const ErrorInfo: React.FC<ErrorProps> = (props) => {
  const { error, onRefetch } = props

  return (
    <Space>
      <Alert
        showIcon
        message={error?.message}
        description={
          error?.response?.data?.message || error?.response?.statusText
        }
        type="error"
      />

      {onRefetch && (
        <Space>
          <Button onClick={onRefetch}>Обновить</Button>
        </Space>
      )}
    </Space>
  )
}

export default React.memo(ErrorInfo)
